import React, { createContext, useState, ReactNode } from 'react';
import BatchUpload from './BatchUpload';

interface BatchUploadContextProps {
  showBatchUpload: boolean;
  setShowBatchUpload: (value: boolean) => void;
}

export const BatchUploadContext = createContext<BatchUploadContextProps>({
  showBatchUpload: false,
  setShowBatchUpload: () => {},
});

export const BatchUploadContextProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [showBatchUpload, setShowBatchUpload] = useState(false);

  const handleCloseBatchUpload = () => setShowBatchUpload(false);

  return (
    <BatchUploadContext.Provider value={{ showBatchUpload, setShowBatchUpload }}>
      {children}
      {showBatchUpload && <BatchUpload onClose={handleCloseBatchUpload} onFileChange={() => {}} onMinimize={() => {}} />}
    </BatchUploadContext.Provider>
  );
};
